/**
 * Readiness Hooks
 * React hooks for readiness checks
 */

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../query-keys'
import { readinessService } from '../services/readiness.service'

/**
 * Hook for readiness check
 */
export function useReadinessCheck() {
  return useQuery({
    queryKey: queryKeys.readiness.check(),
    queryFn: readinessService.getReadiness,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 60000,
  })
}
